module.exports = __webpack_public_path__ + "5ac65440abef38a8f3f46faf7247e8e3.png";